'use strict';

var React = require('react');
var avatar = require('@amzn/stencil-react-components/avatar');
var layout = require('@amzn/stencil-react-components/layout');
require('@amzn/stencil-react-theme-default');
var context = require('@amzn/stencil-react-components/context');
var utils = require('@amzn/stencil-react-components/utils');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*
 * NOTE:
 *
 * This source file was temporarily copied from the 'native-components' package.  Minimal changes
 * were made to use the Stencil web package and associated APIs to provide web support for this
 * component.  This is phase 1 of a multi-phase process to align Stencil native and web APIs so
 * we can more easily manage a single code base for both native and web.  When possible, this
 * component will be re-unified with its native counterpart and duplicate code removed.
 *
 * Ref: https://sim.amazon.com/issues/AtoZPirates-483
 */
var RowConnector = context.styledWithTheme(layout.Row)(function () {
  return {
    alignItems: 'flex-end',
    insetInlineStart: '1px',
    position: 'absolute',
    top: '-34px'
  };
});
var ViewCircle = context.styledWithTheme(layout.View)(function (_ref) {
  var selectors = _ref.theme.selectors;

  var _a;

  return {
    backgroundColor: selectors.color('neutral80'),
    borderRadius: '6px',
    height: '12px',
    marginInlineEnd: "".concat((_a = selectors.space('S200')) !== null && _a !== void 0 ? _a : 0, "px"),
    width: '12px'
  };
});
var ViewHorizontalLine = context.styledWithTheme(layout.View)(function (_ref2) {
  var selectors = _ref2.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral80'),
    height: '2px',
    insetInlineStart: '-1px',
    width: '16px'
  };
});
var ViewVerticalLine = context.styledWithTheme(layout.View)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    backgroundColor: selectors.color('neutral80'),
    width: '2px',
    height: '52px'
  };
});

var Circle = function Circle() {
  return /*#__PURE__*/React__default["default"].createElement(ViewCircle, null);
}; // On the web, the absolutely-positioned StyledConnector is taken out of the row flow, so we need
// a spacer of 10px after it to account for the width.


var Connector = function Connector() {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(RowConnector, null, /*#__PURE__*/React__default["default"].createElement(ViewVerticalLine, null), /*#__PURE__*/React__default["default"].createElement(ViewHorizontalLine, null)), /*#__PURE__*/React__default["default"].createElement(layout.Spacer, {
    width: "12px"
  }));
};

function OrgChart(props) {
  var reportingHierarchy = props.reportingHierarchy;

  var getLevelStyle = function getLevelStyle(index) {
    var levelStyle = {};
    levelStyle.position = 'relative';

    if (index !== 0) {
      levelStyle.marginInlineStart = utils.px(4 + (index - 1) * 16); // RTL version of 'margin-left'
    }

    return levelStyle;
  };

  return /*#__PURE__*/React__default["default"].createElement(layout.Col, {
    gridGap: 'S300'
  }, reportingHierarchy.map(function (_ref4, index) {
    var fullName = _ref4.fullName,
        userName = _ref4.userName,
        profileImageUri = _ref4.profileImageUri,
        title = _ref4.title;
    return /*#__PURE__*/React__default["default"].createElement(layout.Row, {
      alignItems: 'center',
      style: getLevelStyle(index),
      key: userName
    }, index > 0 && /*#__PURE__*/React__default["default"].createElement(Connector, null), /*#__PURE__*/React__default["default"].createElement(Circle, null), /*#__PURE__*/React__default["default"].createElement(avatar.Avatar, {
      fullName: fullName,
      username: userName,
      profileImageUrl: profileImageUri,
      size: avatar.AvatarSize.Small,
      // By default, Stencil makes the username clickable and opens a new tab
      // targeting the Phone Tool with the username.  Disabling this feature
      // of Stencil for now.
      isUsernameClickable: false
    }, /*#__PURE__*/React__default["default"].createElement(avatar.AvatarText, null, title)));
  }));
}

exports.Connector = Connector;
exports.OrgChart = OrgChart;
//# sourceMappingURL=OrgChart-a25cca28.js.map
